import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Easing, Tween } from '@tweenjs/tween.js';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import { report } from '../../../report';
import { MathHelper } from 'Utility/MathHelper';
import { delay } from 'Utility/Task/TaskQueue';
import { AwaitIterators } from '../AnimationHelper';
import { PlaySound } from 'System/Audio/AudioHelper';

interface ISeasonPassRankProgressData {
    progressFill: GameObject;
    tractor: GameObject;
    progress: number;
    progressWidth: number;
    initialDelay?: number;
    onComplete?: () => void;
}

export class SeasonPassRankProgress extends AnimationClip<ISeasonPassRankProgressData> {
    public *execute(animator: GameObject, meta: ISeasonPassRankProgressData): IterableIterator<number> {
        try {
            animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

            if (meta.initialDelay) {
                yield* delay(meta.initialDelay);
            }
            yield* this.fillProgressBar(meta.progressFill, meta.tractor, meta.progressWidth);

            if (meta.onComplete) {
                meta.onComplete();
            }

        } catch (error) {
            report('SeasonPassProgress failed', { error, once: true });
        }
    }

    private *fillProgressBar(progressFill: GameObject, tractor: GameObject, progressWidth: number) {
        const fillTransform = progressFill.getComponent(TransformComponent);
        const tweenWidth: Tween = this.getTween(fillTransform);

        const tractorTransform = tractor.getComponent(TransformComponent);
        const tweenX: Tween = this.getTween(tractorTransform);

        tweenWidth.to({ width: progressWidth }, 1500).easing(Easing.Quartic.InOut);
        tweenX.to({ x: progressWidth }, 1500).easing(Easing.Quartic.InOut);

        PlaySound('tractor');

        yield* AwaitIterators([
            this.startTween(tweenX),
            this.startTween(tweenWidth),
        ]);
    }
}
